/** The company's coupon in use; `applies` says whether the purchase being prepared takes its discount. */
export type CompanyCoupon = { code: string; percentOff: number; periods: number; periodsLeft: number; applies: boolean }
/** The share of `cents` a coupon of `percentOff` takes, rounded to the nearest cent as the server does. */
export function couponDiscount(cents: number, percentOff: number) {
  return Math.round(cents * percentOff / 100)
}
